// import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App as AppAnt } from 'antd';
import App from '@/App.tsx';
import '@/index.scss';
import 'react-quill/dist/quill.snow.css';

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
    <AppAnt>
      <App />
    </AppAnt>
  // </StrictMode>
);
